/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Rozbudowa autocomplete
 *
 * @export
 * @class SearchAutocomplete
 */

export class SearchAutocomplete {
	constructor(options) {
		var defaults = {
			autocomplteBtnLeft: 0,
			autocompleteMinChars: 2,
			topFix: -3,
			miniSize: 43
		};
		this.saSettings = $.extend({}, defaults, options);
		this.saState = {
			autocompleteSugestionsShown: false,
			autocompleteSugestionsLoaded: false //
		};
		this.autocompleteMouseEventTimer = false;
		this.preventSugestionsClosing = false;
	}
	// ****************************************************************************************************
	// Inicjalizacja autouzupełniania podpowiedzi
	// ****************************************************************************************************
	initAutocomplete() {
		var that = this;
		if (pageObj.settings.DOMLoaded) {
			var that = this;
			//that.cont = $('#'+that.settings.mainContID);
			//that.searchInput = $('#'+that.settings.searchInputID);
			that.searchInput.autocomplete({
				serviceUrl: '/Sugestie',
				minChars: that.saSettings.autocompleteMinChars,
				topFix: that.saSettings.topFix,
				miniSize: that.saSettings.miniSize,
				maxHeight: that.autocompleteMaxHeight(),
				width: that.autocompleteWidth(),
				onSearchStart: that.autocompleteSearchStart.bind(that),
				onSearchComplete: that.autocompleteSearchComplete.bind(that),
				onSearchClose: that.autocompleteSearchClose.bind(that),
				onSearchCancel: that.autocompleteSearchCancel.bind(that),
				containerClass: 'autocomplete-suggestions border-right border-left border-bottom rounded-bottom'
			});
			that.autocompleteUpdateBtnLeftPosition();
			that.autocompleteAddControlBtns();
			that.autocompleteAddSugestionsMouseEvents();
		}
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - przeładowanie sugestii np. po zawężeniu kategorii
	// ****************************************************************************************************
	autocompleteReloadSugestions() {
		var that = this;
		if (that.searchInput.val().length >= that.saSettings.autocompleteMinChars) {
			//console.log('autocompleteReloadSugestions');
			that.searchInput.autocomplete('disableKillerFn'); // blokuje samoczynne zamykanie sie podpowiedzi
			that.searchInput.autocomplete('getSuggestions', that.searchInput.val());
		}
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - zdarzenia: on search start
	// ****************************************************************************************************
	autocompleteSearchStart() {
		var that = this;
		//console.log('autocompleteSearchStart');
		//pageObj.scrollPageToNaviStuckState();
		that.searchInput.autocomplete('hide');
		that.saState.autocompleteSugestionsShown = false;
		that.saState.autocompleteSugestionsLoaded = false;
		that.autocompleteUpdateBtnLeftPosition();
		that.searchInput.autocomplete('fixPosition'); // aktualizaca left i top sugestii
		that.searchInput.autocomplete('setOptions', {
			'width': that.autocompleteWidth(),
			'maxHeight': that.autocompleteMaxHeight()
		}); // aktualizacja szerokości sugestii
		$('#autocompleteReopenBtn').hide();
		$('#autocompleteCloseBtn').hide();
		$('#autocompleteLoading').show();
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - zdarzenia: on search complete
	// ****************************************************************************************************
	autocompleteSearchComplete() {
		var that = this;
		//console.log('autocompleteSearchComplete');
		that.saState.autocompleteSugestionsShown = true;
		that.saState.autocompleteSugestionsLoaded = true;
		$('#autocompleteLoading').hide();
		if (pageObj.settings.bootstrap.kind != 'mobile') { // reopen slabo dziala z klawiaturami mobile // +++
			$('#autocompleteReopenBtn').hide();
		}
		$('#autocompleteCloseBtn').show();
		$('.autocomplete-selected').removeClass('autocomplete-selected'); // usuwa podswietlenie opcji wczesniej podswietlonej
		that.autocompleteCheckSagestionsOverflow();
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - zdarzenia: on search close
	// ****************************************************************************************************
	autocompleteSearchClose() {
		var that = this;
		if (that.searchInput.val().length >= that.saSettings.autocompleteMinChars) { // zapobiega odpalaniu eventu, przy pustym query
			//console.log('autocompleteSearchClose');
			that.saState.autocompleteSugestionsShown = false;
			that.saState.autocompleteSugestionsLoaded = true;
			$('#autocompleteLoading').hide();
			$('#autocompleteCloseBtn').hide();
			if (pageObj.settings.bootstrap.kind != 'mobile') { // reopen slabo dziala z klawiaturami mobile // +++
				$('#autocompleteReopenBtn').show();
			}
			if (pageObj.settings.bootstrap.kind != 'mobile') { // mruga na mobilee // +++
				that.searchInput.on('click', function () {
					$('#autocompleteReopenBtn').trigger('click');
					that.preventSugestionsClosing = false;
					$(this).off('click');
				});
			}
		}
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - dodanie eventow kontrloujacych zamykanie okna sugestii
	// ****************************************************************************************************
	autocompleteAddSugestionsMouseEvents() {
		var that = this;
		$('.autocomplete-suggestions, .autocompleteBtn, #' + that.settings.searchInputID).each(function (i, e) {
			$(e).on('mousemove', function () {
				that.preventSugestionsClosing = false;
				if (that.autocompleteMouseEventTimer !== false) {
					clearTimeout(that.autocompleteMouseEventTimer);
					that.autocompleteMouseEventTimer = false;
				}
			}).on('mouseleave', function () {
				if (that.saState.autocompleteSugestionsShown && !that.preventSugestionsClosing) {
					that.autocompleteMouseEventTimer = setTimeout(function () {
						that.autocompleteHide();
					}, POPOVER_LIFE_TIME);
				}
			});
		});
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - zdarzenia: on search cancel (za mała liczba znaków)
	// ****************************************************************************************************
	autocompleteSearchCancel() {
		var that = this;
		//console.log('autocompleteSearchCancel');
		that.saState.autocompleteSugestionsShown = false;
		that.saState.autocompleteSugestionsLoaded = false;
		$('#autocompleteLoading').hide();
		$('#autocompleteCloseBtn').hide();
		if (pageObj.settings.bootstrap.kind != 'mobile') { // reopen slabo dziala z klawiaturami mobile // +++
			$('#autocompleteReopenBtn').hide();
		}
		that.searchInput.off('click');
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - obsługa markera informujacego o większej ilości podpowiedzi
	// ****************************************************************************************************
	autocompleteCheckSagestionsOverflow() {
		var that = this;
		$('.autocomplete-suggestions').each(function (i, e) {
			if (toolsObj.checkOverflow(e)) {
				$('<p class="autocompleteOverflowMarker"></p>').prependTo('.autocomplete-suggestions');
				var style = $('.autocompleteResults').attr('style');
				var resultsHeight = Math.floor(Math.abs($('.autocompleteResults').height() - $('.autocompleteResults').removeAttr('style').height()));
				$('.autocompleteResults').on('scroll', function () {
					if (($(this).scrollTop() + 5) >= resultsHeight) {
						$('.autocompleteOverflowMarker').hide();
						$('.autocomplete-suggestion').last().removeAttr('style');
					}
					else {
						$('.autocompleteOverflowMarker').show();
						$('.autocomplete-suggestion').last().css('margin-bottom', '20px');
					}
				});
				$('.autocompleteResults').attr('style', style);
			}
		});
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - ustawienie pozycji przycisków sterujacych
	// ****************************************************************************************************
	autocompleteAddControlBtns() {
		var that = this;
		$('<img id="autocompleteLoading" class="autocompleteBtn" style="left:' + that.saSettings.autocomplteBtnLeft + 'px; display: none;" src="/img/loading-mini.gif" />').appendTo('#searchFormContainer');
		$('<button id="autocompleteCloseBtn" class="autocompleteBtn close" style="left:' + that.saSettings.autocomplteBtnLeft + 'px; display: none;" type="button" title="' + TXT_CLOSE_SEARCH_HINTS + '" aria-label="' + TXT_CLOSE_SEARCH_HINTS + '"><span aria-hidden="true">&times;</span></button>')
			.appendTo('#searchFormContainer').on('click', function (event) {
				event.stopPropagation();
				that.blockHidingMobileSearchPanel(); // +++ //odwołanie do parent class
				that.searchInput.autocomplete('hide');
				that.autocompleteSearchClose();
			});
		$('<button id="autocompleteReopenBtn" class="autocompleteBtn close" style="left:' + that.saSettings.autocomplteBtnLeft + 'px; display: none;" type="button" title="' + TXT_REOPEN_SEARCH_HINTS + '" aria-label="' + TXT_CLOSE_SEARCH_HINTS + '"><span aria-hidden="true"></span></button>')
			.appendTo('#searchFormContainer').on('click', function (event) {
				event.stopPropagation();
				that.preventSugestionsClosing = true;
				that.blockHidingMobileSearchPanel(); // +++ //odwołanie do parent class
				that.searchInput.autocomplete('show');
				that.searchInput.focus();
				that.searchInput.autocomplete('setOptions', {
					'width': that.autocompleteWidth(),
					'maxHeight': that.autocompleteMaxHeight()
				}); // aktualizacja szerokości i wysokości sugestii
				that.autocompleteSearchComplete();
			});
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - ustawienie pozycji przycisków sterujacych
	// ****************************************************************************************************
	autocompleteUpdateBtnLeftPosition() {
		var that = this;
		that.saSettings.autocomplteBtnLeft = $('#searchFormContainer').width() - $('#advSearchDropdownParent').width() - 30 - 3; // 30 szerokość btns
		var btns = $('.autocompleteBtn');
		if (btns.length > 0)
			btns.css('left', that.saSettings.autocomplteBtnLeft + 'px');
		//console.log('autocompleteUpdateBtnLeftPosition -> autocomplteBtnLeft:', this.saSettings.autocomplteBtnLeft);
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - oblicza maks. wysokość okna autocomplete
	// ****************************************************************************************************
	autocompleteMaxHeight() {
		var that = this;
		if (pageObj.settings.bootstrap.kind == 'desktop') {
			return $(window).height() - this.searchCont.height() - this.searchCont.offset().top + pageObj.settings.scrollingElement.scrollTop() - 10;
		}
		else {
			if (pageObj.settings.bootstrap.orientation == 'horizontal')
				return 80;
			else {
				var h = $(window).height() / 3;
				return (h > 140) ? h : 140;
			}
		}
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - oblicza szerokoci okna autocomplete
	// ****************************************************************************************************
	autocompleteWidth() {
		return $('#searchFormContainer').width() - $('#advSearchDropdownParent').width() + 1;
	}
	// ****************************************************************************************************
	// Rozszerzenie autocomplete - ukrycie podpowiedzi
	// ****************************************************************************************************
	autocompleteHide() {
		if (this.saState.autocompleteSugestionsShown) {
			$('#autocompleteCloseBtn').trigger('click');
		}
	}
}